export enum StorageKey {
  /**
   * 字体大小
   */
  FONT_SIZE = "@font_size",
  /**
   * 用户凭据
   */
  CREDENTIAL = "@credential",
  /**
   * 部门信息
   */
  DEPARTMENTS = "@departments",
  /**
   * 当前用户信息
   */
  CURRENT_USER = "@current_user",
  /**
   * 常用Emoji表情
   */
  RECENT_EMOJI = "@recent_emoji",
  /**
   * 键盘高度
   */
  KEYBOARD_HEIGHT = "@keyboard_height",
  /**
   * 上次更新所有用户时间
   */
  LAST_UPDATE_USERS_TIME = "@last_update_users_time",

  /**
   * 小程序跳转过来的url
   */
  INDEX_URL = "@index_url",

  /**
   * 小程序token
   */
  MIN_PROGRAM_TOKEN = "@min_program_token",
}
